import { render, staticRenderFns } from "./404.vue?vue&type=template&id=d6df0bf2&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=d6df0bf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6df0bf2",
  null
  
)

export default component.exports